import React, { SVGProps } from 'react'
const SvgMoreActive = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="M6 8.25h13a.75.75 0 1 0 0-1.5H6a.75.75 0 0 0 0 1.5zm0 8h13a.75.75 0 1 0 0-1.5H6a.75.75 0 1 0 0 1.5zm0-4h13a.75.75 0 1 0 0-1.5H6a.75.75 0 1 0 0 1.5z"
    />
  </svg>
)
export default SvgMoreActive
